import CACActionChartWrap from "./CACActionChart/CACActionChartWrap";
import CACActionSortWrap from "./CACActionSortWrap";

const CACAction = () => {
  return (
    <>
      <CACActionSortWrap />
      <CACActionChartWrap />
    </>
  );
};

export default CACAction;
